export const hectoClientKey = ''; 
